import { initialState } from './initial';
import { actionTypes } from './actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_DOMAINS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return {
        ...state,
      };
  }
}

export default reducer;
